module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player col-sm-6"
  }, [_c('div', {
    attrs: {
      "id": "player-area"
    }
  }, [_c('div', {
    attrs: {
      "id": "video-player"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-window caption-window-ja"
  }, [_c('span', {
    staticClass: "captions"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group videoid-input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("https://www.youtube.com/watch?v=")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoid),
      expression: "videoid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "basic-addon3"
    },
    domProps: {
      "value": (_vm.videoid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickPlayButton
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-play-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        さﾚヽせﾚヽ\n      ")])])]), _vm._v(" "), (_vm.debug) ? _c('div', [_vm._v(_vm._s(_vm.current))]) : _vm._e(), _vm._v(" "), (_vm.debug) ? _c('div', [_vm._v(_vm._s(_vm.srt['ja']))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0b019c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 225
// module chunks = 1